import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { TicketsSearchState } from '../models/tickets.models';
import * as selectors from '../selectors/tickets-search.selectors';

@Injectable({ providedIn: 'root' })
export class TicketsSearchFacadeService extends FacadeService {
  constructor(public override store: Store<TicketsSearchState>) {
    super(store);
  }

  // OBSERVABLES
  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  sideNav$ = this.storeSelect(selectors.getSideNav);
  canCreateTicket$ = this.storeSelect(selectors.getCanCreateTicket);
  ticketID$ = this.storeSelect(selectors.getTicketID);
  ticketSeverityValues$ = this.storeSelect(selectors.getTicketSeverityValues);
  ticketSeverity$ = this.storeSelect(selectors.getTicketSeverity);
  loyaltySchemaValues$ = this.storeSelect(selectors.getLoyaltySchemaValues);
  loyaltySchema$ = this.storeSelect(selectors.getLoyaltySchema);
  statusValues$ = this.storeSelect(selectors.getStatusValues);
  status$ = this.storeSelect(selectors.getStatus);
  countryValues$ = this.storeSelect(selectors.getCountryValues);
  country$ = this.storeSelect(selectors.getCountry);
  categoryValues$ = this.storeSelect(selectors.getCategoryValues);
  category$ = this.storeSelect(selectors.getCategory);
  assigneeValues$ = this.storeSelect(selectors.getAssigneeValues);
  assignee$ = this.storeSelect(selectors.getAssignee);
  body$ = this.storeSelect(selectors.getBody);
  subject$ = this.storeSelect(selectors.getSubject);
  canViewDetails$ = this.storeSelect(selectors.getCanViewDetails);

  // OBSERVABLES VALUES
  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get ticketSeverityValues() {
    return this.storeSnapshot(this.ticketSeverityValues$);
  }

  get loyaltySchemaValues() {
    return this.storeSnapshot(this.loyaltySchemaValues$);
  }

  get statusValues() {
    return this.storeSnapshot(this.statusValues$);
  }

  get countryValues() {
    return this.storeSnapshot(this.countryValues$);
  }

  get categoryValues() {
    return this.storeSnapshot(this.categoryValues$);
  }

  get assigneeValues() {
    return this.storeSnapshot(this.assigneeValues$);
  }

  get ticketID() {
    return this.storeSnapshot(this.ticketID$);
  }

  get ticketSeverity() {
    return this.storeSnapshot(this.ticketSeverity$);
  }

  get loyaltySchema() {
    return this.storeSnapshot(this.loyaltySchema$);
  }

  get status() {
    return this.storeSnapshot(this.status$);
  }

  get country() {
    return this.storeSnapshot(this.country$);
  }

  get category() {
    return this.storeSnapshot(this.category$);
  }

  get assignee() {
    return this.storeSnapshot(this.assignee$);
  }

  get body() {
    return this.storeSnapshot(this.body$);
  }

  get subject() {
    return this.storeSnapshot(this.subject$);
  }
}
